export default __webpack_public_path__ + "static/media/default-event-icon.cd744592.png";